module.exports = __webpack_public_path__ + "static/media/immotech.f9006a2e.png";